import { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { ErrorState } from '@repo/design-system-kit';
import { useSegment } from '@repo/poly-hooks/segment';
import { useKycContext } from '../context';

interface KycErrorProps {
  onRetry: () => void;
}

export function KycError({ onRetry }: KycErrorProps) {
  const { formatMessage } = useIntl();
  const segment = useSegment();
  const { trackingPrefix } = useKycContext();

  useEffect(() => {
    segment.track(`${trackingPrefix}_kyc_error_screen_loaded`);
  }, [segment, trackingPrefix]);

  return (
    <ErrorState
      onRetry={onRetry}
      retryButtonText={formatMessage({ defaultMessage: 'Try again', id: 'generic.try-again.cta' })}
      retryButtonVariant="primary"
      subtitle={formatMessage({
        defaultMessage: "We couldn't proceed with your request. Can you try again?",
        id: 'kyc.error.subtitle',
      })}
      title={formatMessage({ defaultMessage: 'An error occurred', id: 'kyc.error.title' })}
    />
  );
}
